import countryData from './countries.json';

export const cities = [
  { label: 'Banff', value: 'Banff' },
  { label: 'Brooks', value: 'Brooks' },
  { label: 'Calgary', value: 'Calgary' },
  { label: 'Edmonton', value: 'Edmonton' },
  { label: 'Fort McMurray', value: 'Fort McMurray' },
  { label: 'Grande Prairie', value: 'Grande Prairie' },
  { label: 'Jasper', value: 'Jasper' },
  { label: 'Lake Louise', value: 'Lake Louise' },
  { label: 'Lethbridge', value: 'Lethbridge' },
  { label: 'Medicine Hat', value: 'Medicine Hat' },
  { label: 'Red Deer', value: 'Red Deer' },
  { label: 'Saint Albert', value: 'Saint Albert' },
  { label: 'Barkerville', value: 'Barkerville' },
  { label: 'Burnaby', value: 'Burnaby' },
  { label: 'Campbell River', value: 'Campbell River' },
  { label: 'Chilliwack', value: 'Chilliwack' },
  { label: 'Courtenay', value: 'Courtenay' },
  { label: 'Cranbrook', value: 'Cranbrook' },
  { label: 'Dawson Creek', value: 'Dawson Creek' },
  { label: 'Delta', value: 'Delta' },
  { label: 'Esquimalt', value: 'Esquimalt' },
  { label: 'Fort Saint James', value: 'Fort Saint James' },
  { label: 'Fort Saint John', value: 'Fort Saint John' },
  { label: 'Hope', value: 'Hope' },
  { label: 'Kamloops', value: 'Kamloops' },
  { label: 'Kelowna', value: 'Kelowna' },
  { label: 'Kimberley', value: 'Kimberley' },
  { label: 'Kitimat', value: 'Kitimat' },
  { label: 'Langley', value: 'Langley' },
  { label: 'Nanaimo', value: 'Nanaimo' },
  { label: 'Nelson', value: 'Nelson' },
  { label: 'New Westminster', value: 'New Westminster' },
  { label: 'North Vancouver', value: 'North Vancouver' },
  { label: 'Oak Bay', value: 'Oak Bay' },
  { label: 'Penticton', value: 'Penticton' },
  { label: 'Powell River', value: 'Powell River' },
  { label: 'Prince George', value: 'Prince George' },
  { label: 'Prince Rupert', value: 'Prince Rupert' },
  { label: 'Quesnel', value: 'Quesnel' },
  { label: 'Revelstoke', value: 'Revelstoke' },
  { label: 'Rossland', value: 'Rossland' },
  { label: 'Trail', value: 'Trail' },
  { label: 'Vancouver', value: 'Vancouver' },
  { label: 'Vernon', value: 'Vernon' },
  { label: 'Victoria', value: 'Victoria' },
  { label: 'West Vancouver', value: 'West Vancouver' },
  { label: 'White Rock', value: 'White Rock' },
  { label: 'Brandon', value: 'Brandon' },
  { label: 'Churchill', value: 'Churchill' },
  { label: 'Dauphin', value: 'Dauphin' },
  { label: 'Flin Flon', value: 'Flin Flon' },
  { label: 'Kildonan', value: 'Kildonan' },
  { label: 'Saint Boniface', value: 'Saint Boniface' },
  { label: 'Swan River', value: 'Swan River' },
  { label: 'Thompson', value: 'Thompson' },
  { label: 'Winnipeg', value: 'Winnipeg' },
  { label: 'York Factory', value: 'York Factory' },
  { label: 'Bathurst', value: 'Bathurst' },
  { label: 'Caraquet', value: 'Caraquet' },
  { label: 'Dalhousie', value: 'Dalhousie' },
  { label: 'Fredericton', value: 'Fredericton' },
  { label: 'Miramichi', value: 'Miramichi' },
  { label: 'Moncton', value: 'Moncton' },
  { label: 'Saint John', value: 'Saint John' },
  { label: 'Argentia', value: 'Argentia' },
  { label: 'Bonavista', value: 'Bonavista' },
  { label: 'Channel-Port aux Basques', value: 'Channel-Port aux Basques' },
  { label: 'Corner Brook', value: 'Corner Brook' },
  { label: 'Ferryland', value: 'Ferryland' },
  { label: 'Gander', value: 'Gander' },
  { label: 'Grand Falls–Windsor', value: 'Grand Falls–Windsor' },
  { label: 'Happy Valley–Goose Bay', value: 'Happy Valley–Goose Bay' },
  { label: 'Harbour Grace', value: 'Harbour Grace' },
  { label: 'Labrador City', value: 'Labrador City' },
  { label: 'Placentia', value: 'Placentia' },
  { label: 'Saint Anthony', value: 'Saint Anthony' },
  { label: 'St. John’s', value: 'St. John’s' },
  { label: 'Wabana', value: 'Wabana' },
  { label: 'Fort Smith', value: 'Fort Smith' },
  { label: 'Hay River', value: 'Hay River' },
  { label: 'Inuvik', value: 'Inuvik' },
  { label: 'Tuktoyaktuk', value: 'Tuktoyaktuk' },
  { label: 'Yellowknife', value: 'Yellowknife' },
  { label: 'Baddeck', value: 'Baddeck' },
  { label: 'Digby', value: 'Digby' },
  { label: 'Glace Bay', value: 'Glace Bay' },
  { label: 'Halifax', value: 'Halifax' },
  { label: 'Liverpool', value: 'Liverpool' },
  { label: 'Louisbourg', value: 'Louisbourg' },
  { label: 'Lunenburg', value: 'Lunenburg' },
  { label: 'Pictou', value: 'Pictou' },
  { label: 'Port Hawkesbury', value: 'Port Hawkesbury' },
  { label: 'Springhill', value: 'Springhill' },
  { label: 'Sydney', value: 'Sydney' },
  { label: 'Yarmouth', value: 'Yarmouth' },
  { label: 'Iqaluit', value: 'Iqaluit' },
  { label: 'Bancroft', value: 'Bancroft' },
  { label: 'Barrie', value: 'Barrie' },
  { label: 'Belleville', value: 'Belleville' },
  { label: 'Brampton', value: 'Brampton' },
  { label: 'Brantford', value: 'Brantford' },
  { label: 'Brockville', value: 'Brockville' },
  { label: 'Burlington', value: 'Burlington' },
  { label: 'Cambridge', value: 'Cambridge' },
  { label: 'Chatham', value: 'Chatham' },
  { label: 'Chatham-Kent', value: 'Chatham-Kent' },
  { label: 'Cornwall', value: 'Cornwall' },
  { label: 'Elliot Lake', value: 'Elliot Lake' },
  { label: 'Etobicoke', value: 'Etobicoke' },
  { label: 'Fort Erie', value: 'Fort Erie' },
  { label: 'Fort Frances', value: 'Fort Frances' },
  { label: 'Gananoque', value: 'Gananoque' },
  { label: 'Guelph', value: 'Guelph' },
  { label: 'Hamilton', value: 'Hamilton' },
  { label: 'Iroquois Falls', value: 'Iroquois Falls' },
  { label: 'Kapuskasing', value: 'Kapuskasing' },
  { label: 'Kawartha Lakes', value: 'Kawartha Lakes' },
  { label: 'Kenora', value: 'Kenora' },
  { label: 'Kingston', value: 'Kingston' },
  { label: 'Kirkland Lake', value: 'Kirkland Lake' },
  { label: 'Kitchener', value: 'Kitchener' },
  { label: 'Laurentian Hills', value: 'Laurentian Hills' },
  { label: 'London', value: 'London' },
  { label: 'Midland', value: 'Midland' },
  { label: 'Mississauga', value: 'Mississauga' },
  { label: 'Moose Factory', value: 'Moose Factory' },
  { label: 'Moosonee', value: 'Moosonee' },
  { label: 'Niagara Falls', value: 'Niagara Falls' },
  { label: 'Niagara-on-the-Lake', value: 'Niagara-on-the-Lake' },
  { label: 'North Bay', value: 'North Bay' },
  { label: 'North York', value: 'North York' },
  { label: 'Oakville', value: 'Oakville' },
  { label: 'Orillia', value: 'Orillia' },
  { label: 'Oshawa', value: 'Oshawa' },
  { label: 'Ottawa', value: 'Ottawa' },
  { label: 'Parry Sound', value: 'Parry Sound' },
  { label: 'Perth', value: 'Perth' },
  { label: 'Peterborough', value: 'Peterborough' },
  { label: 'Picton', value: 'Picton' },
  { label: 'Port Colborne', value: 'Port Colborne' },
  { label: 'Saint Catharines', value: 'Saint Catharines' },
  { label: 'Saint Thomas', value: 'Saint Thomas' },
  { label: 'Sarnia-Clearwater', value: 'Sarnia-Clearwater' },
  { label: 'Sault Sainte Marie', value: 'Sault Sainte Marie' },
  { label: 'Scarborough', value: 'Scarborough' },
  { label: 'Simcoe', value: 'Simcoe' },
  { label: 'Stratford', value: 'Stratford' },
  { label: 'Sudbury', value: 'Sudbury' },
  { label: 'Temiskaming Shores', value: 'Temiskaming Shores' },
  { label: 'Thorold', value: 'Thorold' },
  { label: 'Thunder Bay', value: 'Thunder Bay' },
  { label: 'Timmins', value: 'Timmins' },
  { label: 'Toronto', value: 'Toronto' },
  { label: 'Trenton', value: 'Trenton' },
  { label: 'Waterloo', value: 'Waterloo' },
  { label: 'Welland', value: 'Welland' },
  { label: 'West Nipissing', value: 'West Nipissing' },
  { label: 'Windsor', value: 'Windsor' },
  { label: 'Woodstock', value: 'Woodstock' },
  { label: 'York', value: 'York' },
  { label: 'Borden', value: 'Borden' },
  { label: 'Cavendish', value: 'Cavendish' },
  { label: 'Charlottetown', value: 'Charlottetown' },
  { label: 'Souris', value: 'Souris' },
  { label: 'Summerside', value: 'Summerside' },
  { label: 'Asbestos', value: 'Asbestos' },
  { label: 'Baie-Comeau', value: 'Baie-Comeau' },
  { label: 'Beloeil', value: 'Beloeil' },
  { label: 'Cap-de-la-Madeleine', value: 'Cap-de-la-Madeleine' },
  { label: 'Chambly', value: 'Chambly' },
  { label: 'Charlesbourg', value: 'Charlesbourg' },
  { label: 'Châteauguay', value: 'Châteauguay' },
  { label: 'Chibougamau', value: 'Chibougamau' },
  { label: 'Côte-Saint-Luc', value: 'Côte-Saint-Luc' },
  { label: 'Dorval', value: 'Dorval' },
  { label: 'Gaspé', value: 'Gaspé' },
  { label: 'Gatineau', value: 'Gatineau' },
  { label: 'Granby', value: 'Granby' },
  { label: 'Havre-Saint-Pierre', value: 'Havre-Saint-Pierre' },
  { label: 'Hull', value: 'Hull' },
  { label: 'Jonquière', value: 'Jonquière' },
  { label: 'Kuujjuaq', value: 'Kuujjuaq' },
  { label: 'La Salle', value: 'La Salle' },
  { label: 'La Tuque', value: 'La Tuque' },
  { label: 'Lachine', value: 'Lachine' },
  { label: 'Laval', value: 'Laval' },
  { label: 'Lévis', value: 'Lévis' },
  { label: 'Longueuil', value: 'Longueuil' },
  { label: 'Magog', value: 'Magog' },
  { label: 'Matane', value: 'Matane' },
  { label: 'Montreal', value: 'Montreal' },
  { label: 'Montréal-Nord', value: 'Montréal-Nord' },
  { label: 'Percé', value: 'Percé' },
  { label: 'Port-Cartier', value: 'Port-Cartier' },
  { label: 'Quebec', value: 'Quebec' },
  { label: 'Rimouski', value: 'Rimouski' },
  { label: 'Rouyn-Noranda', value: 'Rouyn-Noranda' },
  { label: 'Saguenay', value: 'Saguenay' },
  { label: 'Saint-Eustache', value: 'Saint-Eustache' },
  { label: 'Saint-Hubert', value: 'Saint-Hubert' },
  { label: 'Sainte-Anne-de-Beaupré', value: 'Sainte-Anne-de-Beaupré' },
  { label: 'Sainte-Foy', value: 'Sainte-Foy' },
  { label: 'Sainte-Thérèse', value: 'Sainte-Thérèse' },
  { label: 'Sept-Îles', value: 'Sept-Îles' },
  { label: 'Sherbrooke', value: 'Sherbrooke' },
  { label: 'Sorel-Tracy', value: 'Sorel-Tracy' },
  { label: 'Trois-Rivières', value: 'Trois-Rivières' },
  { label: 'Val-d’Or', value: 'Val-d’Or' },
  { label: 'Waskaganish', value: 'Waskaganish' },
  { label: 'Batoche', value: 'Batoche' },
  { label: 'Cumberland House', value: 'Cumberland House' },
  { label: 'Estevan', value: 'Estevan' },
  { label: 'Flin Flon', value: 'Flin Flon' },
  { label: 'Moose Jaw', value: 'Moose Jaw' },
  { label: 'Prince Albert', value: 'Prince Albert' },
  { label: 'Regina', value: 'Regina' },
  { label: 'Saskatoon', value: 'Saskatoon' },
  { label: 'Uranium City', value: 'Uranium City' },
  { label: 'Dawson', value: 'Dawson' },
  { label: 'Watson Lake', value: 'Watson Lake' },
  { label: 'Whitehorse', value: 'Whitehorse' },
];

export const canadaState = [
  {
    label: 'Alberta',
    value: 'Alberta',
    cities: [
      { label: 'Banff', value: 'Banff' },
      { label: 'Brooks', value: 'Brooks' },
      { label: 'Calgary', value: 'Calgary' },
      { label: 'Edmonton', value: 'Edmonton' },
      { label: 'Fort McMurray', value: 'Fort McMurray' },
      { label: 'Grande Prairie', value: 'Grande Prairie' },
      { label: 'Jasper', value: 'Jasper' },
      { label: 'Lake Louise', value: 'Lake Louise' },
      { label: 'Lethbridge', value: 'Lethbridge' },
      { label: 'Medicine Hat', value: 'Medicine Hat' },
      { label: 'Red Deer', value: 'Red Deer' },
      { label: 'Saint Albert', value: 'Saint Albert' },
    ],
  },
  {
    label: 'British Columbia',
    value: 'British Columbia',
    cities: [
      { label: 'Barkerville', value: 'Barkerville' },
      { label: 'Burnaby', value: 'Burnaby' },
      { label: 'Campbell River', value: 'Campbell River' },
      { label: 'Chilliwack', value: 'Chilliwack' },
      { label: 'Courtenay', value: 'Courtenay' },
      { label: 'Cranbrook', value: 'Cranbrook' },
      { label: 'Dawson Creek', value: 'Dawson Creek' },
      { label: 'Delta', value: 'Delta' },
      { label: 'Esquimalt', value: 'Esquimalt' },
      { label: 'Fort Saint James', value: 'Fort Saint James' },
      { label: 'Fort Saint John', value: 'Fort Saint John' },
      { label: 'Hope', value: 'Hope' },
      { label: 'Kamloops', value: 'Kamloops' },
      { label: 'Kelowna', value: 'Kelowna' },
      { label: 'Kimberley', value: 'Kimberley' },
      { label: 'Kitimat', value: 'Kitimat' },
      { label: 'Langley', value: 'Langley' },
      { label: 'Nanaimo', value: 'Nanaimo' },
      { label: 'Nelson', value: 'Nelson' },
      { label: 'New Westminster', value: 'New Westminster' },
      { label: 'North Vancouver', value: 'North Vancouver' },
      { label: 'Oak Bay', value: 'Oak Bay' },
      { label: 'Penticton', value: 'Penticton' },
      { label: 'Powell River', value: 'Powell River' },
      { label: 'Prince George', value: 'Prince George' },
      { label: 'Prince Rupert', value: 'Prince Rupert' },
      { label: 'Quesnel', value: 'Quesnel' },
      { label: 'Revelstoke', value: 'Revelstoke' },
      { label: 'Rossland', value: 'Rossland' },
      { label: 'Trail', value: 'Trail' },
      { label: 'Vancouver', value: 'Vancouver' },
      { label: 'Vernon', value: 'Vernon' },
      { label: 'Victoria', value: 'Victoria' },
      { label: 'West Vancouver', value: 'West Vancouver' },
      { label: 'White Rock', value: 'White Rock' },
    ],
  },
  {
    label: 'Manitoba',
    value: 'Manitoba',
    cities: [
      { label: 'Brandon', value: 'Brandon' },
      { label: 'Churchill', value: 'Churchill' },
      { label: 'Dauphin', value: 'Dauphin' },
      { label: 'Flin Flon', value: 'Flin Flon' },
      { label: 'Kildonan', value: 'Kildonan' },
      { label: 'Saint Boniface', value: 'Saint Boniface' },
      { label: 'Swan River', value: 'Swan River' },
      { label: 'Thompson', value: 'Thompson' },
      { label: 'Winnipeg', value: 'Winnipeg' },
      { label: 'York Factory', value: 'York Factory' },
    ],
  },
  {
    label: 'New Brunswick',
    value: 'New Brunswick',
    cities: [
      { label: 'Bathurst', value: 'Bathurst' },
      { label: 'Caraquet', value: 'Caraquet' },
      { label: 'Dalhousie', value: 'Dalhousie' },
      { label: 'Fredericton', value: 'Fredericton' },
      { label: 'Miramichi', value: 'Miramichi' },
      { label: 'Moncton', value: 'Moncton' },
      { label: 'Saint John', value: 'Saint John' },
    ],
  },
  {
    label: 'Newfoundland and Labrador',
    value: 'Newfoundland and Labrador',
    cities: [
      { label: 'Argentia', value: 'Argentia' },
      { label: 'Bonavista', value: 'Bonavista' },
      { label: 'Channel-Port aux Basques', value: 'Channel-Port aux Basques' },
      { label: 'Corner Brook', value: 'Corner Brook' },
      { label: 'Ferryland', value: 'Ferryland' },
      { label: 'Gander', value: 'Gander' },
      { label: 'Grand Falls–Windsor', value: 'Grand Falls–Windsor' },
      { label: 'Happy Valley–Goose Bay', value: 'Happy Valley–Goose Bay' },
      { label: 'Harbour Grace', value: 'Harbour Grace' },
      { label: 'Labrador City', value: 'Labrador City' },
      { label: 'Placentia', value: 'Placentia' },
      { label: 'Saint Anthony', value: 'Saint Anthony' },
      { label: 'St. John’s', value: 'St. John’s' },
      { label: 'Wabana', value: 'Wabana' },
    ],
  },
  {
    label: 'Northwest Territories',
    value: 'Northwest Territories',
    cities: [
      { label: 'Fort Smith', value: 'Fort Smith' },
      { label: 'Hay River', value: 'Hay River' },
      { label: 'Inuvik', value: 'Inuvik' },
      { label: 'Tuktoyaktuk', value: 'Tuktoyaktuk' },
      { label: 'Yellowknife', value: 'Yellowknife' },
    ],
  },
  {
    label: 'Nova Scotia',
    value: 'Nova Scotia',
    cities: [
      { label: 'Baddeck', value: 'Baddeck' },
      { label: 'Digby', value: 'Digby' },
      { label: 'Glace Bay', value: 'Glace Bay' },
      { label: 'Halifax', value: 'Halifax' },
      { label: 'Liverpool', value: 'Liverpool' },
      { label: 'Louisbourg', value: 'Louisbourg' },
      { label: 'Lunenburg', value: 'Lunenburg' },
      { label: 'Pictou', value: 'Pictou' },
      { label: 'Port Hawkesbury', value: 'Port Hawkesbury' },
      { label: 'Springhill', value: 'Springhill' },
      { label: 'Sydney', value: 'Sydney' },
      { label: 'Yarmouth', value: 'Yarmouth' },
    ],
  },
  {
    label: 'Nunavut',
    value: 'Nunavut',
    cities: [{ label: 'Iqaluit', value: 'Iqaluit' }],
  },
  {
    label: 'Ontario',
    value: 'Ontario',
    cities: [
      { label: 'Bancroft', value: 'Bancroft' },
      { label: 'Barrie', value: 'Barrie' },
      { label: 'Belleville', value: 'Belleville' },
      { label: 'Brampton', value: 'Brampton' },
      { label: 'Brantford', value: 'Brantford' },
      { label: 'Brockville', value: 'Brockville' },
      { label: 'Burlington', value: 'Burlington' },
      { label: 'Cambridge', value: 'Cambridge' },
      { label: 'Chatham', value: 'Chatham' },
      { label: 'Chatham-Kent', value: 'Chatham-Kent' },
      { label: 'Cornwall', value: 'Cornwall' },
      { label: 'Elliot Lake', value: 'Elliot Lake' },
      { label: 'Etobicoke', value: 'Etobicoke' },
      { label: 'Fort Erie', value: 'Fort Erie' },
      { label: 'Fort Frances', value: 'Fort Frances' },
      { label: 'Gananoque', value: 'Gananoque' },
      { label: 'Guelph', value: 'Guelph' },
      { label: 'Hamilton', value: 'Hamilton' },
      { label: 'Iroquois Falls', value: 'Iroquois Falls' },
      { label: 'Kapuskasing', value: 'Kapuskasing' },
      { label: 'Kawartha Lakes', value: 'Kawartha Lakes' },
      { label: 'Kenora', value: 'Kenora' },
      { label: 'Kingston', value: 'Kingston' },
      { label: 'Kirkland Lake', value: 'Kirkland Lake' },
      { label: 'Kitchener', value: 'Kitchener' },
      { label: 'Laurentian Hills', value: 'Laurentian Hills' },
      { label: 'London', value: 'London' },
      { label: 'Midland', value: 'Midland' },
      { label: 'Mississauga', value: 'Mississauga' },
      { label: 'Moose Factory', value: 'Moose Factory' },
      { label: 'Moosonee', value: 'Moosonee' },
      { label: 'Niagara Falls', value: 'Niagara Falls' },
      { label: 'Niagara-on-the-Lake', value: 'Niagara-on-the-Lake' },
      { label: 'North Bay', value: 'North Bay' },
      { label: 'North York', value: 'North York' },
      { label: 'Oakville', value: 'Oakville' },
      { label: 'Orillia', value: 'Orillia' },
      { label: 'Oshawa', value: 'Oshawa' },
      { label: 'Ottawa', value: 'Ottawa' },
      { label: 'Parry Sound', value: 'Parry Sound' },
      { label: 'Perth', value: 'Perth' },
      { label: 'Peterborough', value: 'Peterborough' },
      { label: 'Picton', value: 'Picton' },
      { label: 'Port Colborne', value: 'Port Colborne' },
      { label: 'Saint Catharines', value: 'Saint Catharines' },
      { label: 'Saint Thomas', value: 'Saint Thomas' },
      { label: 'Sarnia-Clearwater', value: 'Sarnia-Clearwater' },
      { label: 'Sault Sainte Marie', value: 'Sault Sainte Marie' },
      { label: 'Scarborough', value: 'Scarborough' },
      { label: 'Simcoe', value: 'Simcoe' },
      { label: 'Stratford', value: 'Stratford' },
      { label: 'Sudbury', value: 'Sudbury' },
      { label: 'Temiskaming Shores', value: 'Temiskaming Shores' },
      { label: 'Thorold', value: 'Thorold' },
      { label: 'Thunder Bay', value: 'Thunder Bay' },
      { label: 'Timmins', value: 'Timmins' },
      { label: 'Toronto', value: 'Toronto' },
      { label: 'Trenton', value: 'Trenton' },
      { label: 'Waterloo', value: 'Waterloo' },
      { label: 'Welland', value: 'Welland' },
      { label: 'West Nipissing', value: 'West Nipissing' },
      { label: 'Windsor', value: 'Windsor' },
      { label: 'Woodstock', value: 'Woodstock' },
      { label: 'York', value: 'York' },
    ],
  },
  {
    label: 'Prince Edward Island',
    value: 'Prince Edward Island',
    cities: [
      { label: 'Borden', value: 'Borden' },
      { label: 'Cavendish', value: 'Cavendish' },
      { label: 'Charlottetown', value: 'Charlottetown' },
      { label: 'Souris', value: 'Souris' },
      { label: 'Summerside', value: 'Summerside' },
    ],
  },
  {
    label: 'Quebec',
    value: 'Quebec',
    cities: [
      { label: 'Asbestos', value: 'Asbestos' },
      { label: 'Baie-Comeau', value: 'Baie-Comeau' },
      { label: 'Beloeil', value: 'Beloeil' },
      { label: 'Cap-de-la-Madeleine', value: 'Cap-de-la-Madeleine' },
      { label: 'Chambly', value: 'Chambly' },
      { label: 'Charlesbourg', value: 'Charlesbourg' },
      { label: 'Châteauguay', value: 'Châteauguay' },
      { label: 'Chibougamau', value: 'Chibougamau' },
      { label: 'Côte-Saint-Luc', value: 'Côte-Saint-Luc' },
      { label: 'Dorval', value: 'Dorval' },
      { label: 'Gaspé', value: 'Gaspé' },
      { label: 'Gatineau', value: 'Gatineau' },
      { label: 'Granby', value: 'Granby' },
      { label: 'Havre-Saint-Pierre', value: 'Havre-Saint-Pierre' },
      { label: 'Hull', value: 'Hull' },
      { label: 'Jonquière', value: 'Jonquière' },
      { label: 'Kuujjuaq', value: 'Kuujjuaq' },
      { label: 'La Salle', value: 'La Salle' },
      { label: 'La Tuque', value: 'La Tuque' },
      { label: 'Lachine', value: 'Lachine' },
      { label: 'Laval', value: 'Laval' },
      { label: 'Lévis', value: 'Lévis' },
      { label: 'Longueuil', value: 'Longueuil' },
      { label: 'Magog', value: 'Magog' },
      { label: 'Matane', value: 'Matane' },
      { label: 'Montreal', value: 'Montreal' },
      { label: 'Montréal-Nord', value: 'Montréal-Nord' },
      { label: 'Percé', value: 'Percé' },
      { label: 'Port-Cartier', value: 'Port-Cartier' },
      { label: 'Quebec', value: 'Quebec' },
      { label: 'Rimouski', value: 'Rimouski' },
      { label: 'Rouyn-Noranda', value: 'Rouyn-Noranda' },
      { label: 'Saguenay', value: 'Saguenay' },
      { label: 'Saint-Eustache', value: 'Saint-Eustache' },
      { label: 'Saint-Hubert', value: 'Saint-Hubert' },
      { label: 'Sainte-Anne-de-Beaupré', value: 'Sainte-Anne-de-Beaupré' },
      { label: 'Sainte-Foy', value: 'Sainte-Foy' },
      { label: 'Sainte-Thérèse', value: 'Sainte-Thérèse' },
      { label: 'Sept-Îles', value: 'Sept-Îles' },
      { label: 'Sherbrooke', value: 'Sherbrooke' },
      { label: 'Sorel-Tracy', value: 'Sorel-Tracy' },
      { label: 'Trois-Rivières', value: 'Trois-Rivières' },
      { label: 'Val-d’Or', value: 'Val-d’Or' },
      { label: 'Waskaganish', value: 'Waskaganish' },
    ],
  },
  {
    label: 'Saskatchewan',
    value: 'Saskatchewan',
    cities: [
      { label: 'Batoche', value: 'Batoche' },
      { label: 'Cumberland House', value: 'Cumberland House' },
      { label: 'Estevan', value: 'Estevan' },
      { label: 'Flin Flon', value: 'Flin Flon' },
      { label: 'Moose Jaw', value: 'Moose Jaw' },
      { label: 'Prince Albert', value: 'Prince Albert' },
      { label: 'Regina', value: 'Regina' },
      { label: 'Saskatoon', value: 'Saskatoon' },
      { label: 'Uranium City', value: 'Uranium City' },
    ],
  },
  {
    label: 'Yukon',
    value: 'Yukon',
    cities: [
      { label: 'Dawson', value: 'Dawson' },
      { label: 'Watson Lake', value: 'Watson Lake' },
      { label: 'Whitehorse', value: 'Whitehorse' },
    ],
  },
];

export const getCountries = () => countryData.countries;

export const hasCityInList = (country: string, city: string) => {
  const data: any = countryData.countryStateObj;
  const states = data[country]?.states || [];
  const isCity = states?.find((item: any) => item?.value === city);
  return !!isCity;
};

export const getCities = (country: string) => {
  const data: any = countryData.countryStateObj;
  return data[country]?.states || [];
};
